import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { loginSchema } from '../features/auth/authSchema'
import FormInput from './FormInput'
import Button from "../components/UI/Button"
import { Link } from 'react-router-dom';

type FormData = z.infer<typeof loginSchema>

interface Props {
  onSubmit: (data: FormData) => void
  isLoading: boolean
  message: string
  error: string
}

const LoginForm = ({ onSubmit, isLoading, message, error }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({ resolver: zodResolver(loginSchema) })

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="bg-secondary p-8 rounded-xl shadow-card w-full max-w-md space-y-4"
      dir="rtl"
    >
     <h2 className="text-3xl font-bold text-center text-primary">התחברות</h2>

      <FormInput
        label="אימייל"
        type="email"
        register={register('email')}
        error={errors.email?.message}
        placeholder="הכנס אימייל"
      />

      <FormInput
        label="סיסמא"
        type="password"
        register={register('password')}
        error={errors.password?.message}
        placeholder="הכנס סיסמא"
      />

      <Button type="submit" fullWidth isLoading={isLoading}>
        התחבר
      </Button>

      {message && <p className="text-success text-center text-sm font-medium">{message}</p>}
      {error &&<p className="text-danger text-center text-sm font-medium">{error}</p>}

      <Link to="/forgot-password" className="underline text-black hover:text-gray-700">שכחתי סיסמה?</Link>
      
    </form>
  )
}

export default LoginForm
